module.exports = __webpack_public_path__ + "img/download-app-banner.1bc330fc.png";